export { default as PopoutErrorBoundary } from './components/PopoutErrorBoundary';
export { default as WidgetWindowPortal } from './components/WidgetWindowPortal';
export { default as WidgetPopoutPlaceholder } from './components/WidgetPopoutPlaceholder';
export { canWidgetUsePopout } from './config/widgetPopout.config';
export { default as useWidgetPopout } from './hooks/useWidgetPopout';
